import { render, staticRenderFns } from "./TgHistoryContribution.vue?vue&type=template&id=16eae5f6"
import script from "./TgHistoryContribution.vue?vue&type=script&lang=js"
export * from "./TgHistoryContribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports